export class MappedFromData {
  public fileName: string;
  public name: string;
  public index: number;

  constructor(fileName: string, name: string, index: number) {
    this.fileName = fileName;
    this.name = name;
    this.index = index;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/data/MappedFromData.ts